import { render, staticRenderFns } from "./BottomInputs.vue?vue&type=template&id=58636916&"
import script from "./BottomInputs.vue?vue&type=script&lang=js&"
export * from "./BottomInputs.vue?vue&type=script&lang=js&"
import style0 from "./BottomInputs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports